
(function() {
  var result = { translations: { "zh-cn": { "i18n": { "duration": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206\u949F", "hours": "{{ hours }} \u5C0F\u65F6", "hoursAndMinutes": "{{ hours }} \u5C0F\u65F6 {{ minutes }} \u5206\u949F", "days": "{{ days }} \u5929", "shortForm": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206\u949F", "hours": "{{ hours }} \u5C0F\u65F6", "days": "{{ days }} \u5929", "hoursAndMinutes": "{{ hours }} \u5C0F\u65F6 {{ minutes }} \u5206\u949F" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} \u5E74\u7B2C {{quarterNumber}} \u5B63\u5EA6" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}\uFF0C\u5206\u673A {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "zh-cn": "static-7.1084"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1084",
    "ar-eg": "static-7.1084",
    "bg": "static-7.1084",
    "bn": "static-7.1084",
    "ca-es": "static-7.1084",
    "cs": "static-7.1084",
    "da": "static-7.1084",
    "de": "static-7.1084",
    "el": "static-7.1084",
    "en-gb": "static-7.1084",
    "en": "static-7.1084",
    "es-mx": "static-7.1084",
    "es": "static-7.1084",
    "et": "static-7.1084",
    "fi": "static-7.1084",
    "fr-ca": "static-7.1084",
    "fr": "static-7.1084",
    "he-il": "static-7.1084",
    "hi": "static-7.1084",
    "hr": "static-7.1084",
    "hu": "static-7.1084",
    "id": "static-7.1084",
    "it": "static-7.1084",
    "ja": "static-7.1084",
    "ko": "static-7.1084",
    "lt": "static-7.1084",
    "ms": "static-7.1084",
    "nl": "static-7.1084",
    "no": "static-7.1084",
    "pl": "static-7.1084",
    "pt-br": "static-7.1084",
    "pt-pt": "static-7.1084",
    "ro": "static-7.1084",
    "ru": "static-7.1084",
    "sk": "static-7.1084",
    "sl": "static-7.1084",
    "sv": "static-7.1084",
    "th": "static-7.1084",
    "tl": "static-7.1084",
    "tr": "static-7.1084",
    "uk": "static-7.1084",
    "vi": "static-7.1084",
    "x-pseudo": "static-7.1084",
    "zh-cn": "static-7.1084",
    "zh-hk": "static-7.1084",
    "zh-tw": "static-7.1084"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:zh-cn', {version: 'static-7.1084'}); }
})();


